import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/blbc_logo.svg';

function Footer() {
  const head = {
    fontFamily: 'var(--font-serif)',
    fontWeight: 400,
    fontSize: '17px',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: 'var(--tan-200)',
    margin: '0 0 18px',
  };
  const link = {
    color: 'rgba(255,255,255,0.78)',
    textDecoration: 'none',
    fontSize: '15px',
    transition: 'color 0.2s var(--ease)',
    display: 'block',
  };
  const onEnter = (e) => { e.currentTarget.style.color = '#fff'; };
  const onLeave = (e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.78)'; };
  const col = { display: 'grid', gap: '13px', alignContent: 'start' };

  return (
    <footer style={{
      background: 'linear-gradient(to bottom, #3a0606, #220303)',
      color: '#fff',
      marginTop: 'auto',
    }}>
      <div
        className="ds-grid-4 ds-section-y"
        style={{
          maxWidth: 'var(--maxw)',
          margin: '0 auto',
          padding: '88px var(--gutter) 40px',
          display: 'grid',
          gridTemplateColumns: '1.6fr 1fr 1fr 1.1fr',
          gap: '64px',
        }}
      >
        <div>
          <img src={logo} alt="BLBC" style={{ height: '62px', marginBottom: '22px' }} />
          <p style={{ opacity: 0.82, lineHeight: 1.85, fontSize: '15px', maxWidth: '330px', margin: 0 }}>
            A community of believers dedicated to sharing God's love and preaching His word in Heath Springs and beyond.
          </p>
        </div>
        <div style={col}>
          <h4 style={head}>Explore</h4>
          <Link to="/about" style={link} onMouseEnter={onEnter} onMouseLeave={onLeave}>About Us</Link>
          <Link to="/sermons" style={link} onMouseEnter={onEnter} onMouseLeave={onLeave}>Sermons</Link>
          <Link to="/events" style={link} onMouseEnter={onEnter} onMouseLeave={onLeave}>Events</Link>
          <Link to="/ministries" style={link} onMouseEnter={onEnter} onMouseLeave={onLeave}>Ministries</Link>
        </div>
        <div style={col}>
          <h4 style={head}>Connect</h4>
          <Link to="/contact" style={link} onMouseEnter={onEnter} onMouseLeave={onLeave}>Plan Your Visit</Link>
          <Link to="/contact" style={link} onMouseEnter={onEnter} onMouseLeave={onLeave}>Prayer Request</Link>
          <Link to="/contact" style={link} onMouseEnter={onEnter} onMouseLeave={onLeave}>Volunteer</Link>
          <Link to="/contact" style={link} onMouseEnter={onEnter} onMouseLeave={onLeave}>Give Online</Link>
        </div>
        <div style={col}>
          <h4 style={head}>Gather With Us</h4>
          <div style={{ display: 'grid', gap: '10px', fontSize: '15px', lineHeight: 1.5, color: 'rgba(255,255,255,0.82)' }}>
            <div><strong style={{ color: '#fff', fontWeight: 600 }}>Sunday School</strong><br />9:50 AM</div>
            <div><strong style={{ color: '#fff', fontWeight: 600 }}>Sunday Worship</strong><br />11:00 AM</div>
            <div><strong style={{ color: '#fff', fontWeight: 600 }}>Wednesday Bible Study</strong><br />6:30 PM</div>
          </div>
        </div>
      </div>
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.12)' }}>
        <div style={{ maxWidth: 'var(--maxw)', margin: '0 auto', padding: '24px var(--gutter)', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', fontSize: '13px', color: 'rgba(255,255,255,0.6)' }}>
          <span>© 2026 Bright Light Baptist Church. All Rights Reserved.</span>
          <span>4469 Kershaw Camden Hwy, Heath Springs, SC 29058 · (803) 273-9220</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
